import { ECollaboratorInviteRole } from '@lifk/types';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const AddCollaboratorValidationSchema = z.object({
    userId: UUIDValidationSchema,
    token: UUIDValidationSchema,
    firstName: z.string(),
    lastName: z.string(),
    email: z.string()
});
const UpdateCollaboratorValidationSchema = z.object({
    userId: UUIDValidationSchema,
    workshopId: UUIDValidationSchema,
    invalidated: z.boolean(),
    role: z.nativeEnum(ECollaboratorInviteRole).optional()
});
export { AddCollaboratorValidationSchema, UpdateCollaboratorValidationSchema };
//# sourceMappingURL=collaborator.js.map